'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _ErrorFilled = require('./lib/icons/ErrorFilled');
  
  
  var _default = _ErrorFilled;
  exports.default = _default;
  module.exports = _default;